"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function FileExtension({ title, size }) {
    const extension = title.split(".").pop();
    const getStyle = () => {
        switch (extension) {
            case "pdf":
                return "has-background-extension-orange";
            case "jpg":
                return "has-background-extension-blue";
            case "png":
                return "has-background-extension-blue";
            case "doc":
                return "has-background-extension-darkblue";
            case "docx":
                return "has-background-extension-darkblue";
            default:
                return "has-background-extension-default";
        }
    };
    return (react_1.default.createElement("div", { className: "is-flex p-2 is-align-items-center" },
        react_1.default.createElement("figure", { className: `${getStyle()} image is-24x24 border-radius-small is-flex is-justify-content-center is-align-items-center` }, getStyle() !== "has-background-extension-default" && (react_1.default.createElement("p", { className: "is-size-8 has-text-white is-uppercase p-1" }, extension === "docx" ? "doc" : extension))),
        react_1.default.createElement("p", { className: "ml-2 has-text-black100 has-text-weight-medium is-size-8 is-size-7-tablet is-flex is-flex-direction-column" },
            react_1.default.createElement("span", null, title),
            size && react_1.default.createElement("span", { className: "mt-1" }, size))));
}
exports.default = FileExtension;
//# sourceMappingURL=FileExtension.js.map